var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleRightB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.54 11.29L9.88001 5.64004C9.78705 5.54631 9.67645 5.47191 9.55459 5.42115C9.43273 5.37038 9.30202 5.34424 9.17001 5.34424C9.038 5.34424 8.90729 5.37038 8.78544 5.42115C8.66358 5.47191 8.55298 5.54631 8.46001 5.64004C8.27376 5.8274 8.16922 6.08085 8.16922 6.34504C8.16922 6.60922 8.27376 6.86267 8.46001 7.05004L13.41 12.05L8.46001 17C8.27376 17.1874 8.16922 17.4409 8.16922 17.705C8.16922 17.9692 8.27376 18.2227 8.46001 18.41C8.55263 18.5045 8.66307 18.5797 8.78495 18.6312C8.90682 18.6827 9.03771 18.7095 9.17001 18.71C9.30232 18.7095 9.4332 18.6827 9.55508 18.6312C9.67695 18.5797 9.7874 18.5045 9.88001 18.41L15.54 12.76C15.6415 12.6664 15.7225 12.5527 15.7779 12.4262C15.8333 12.2997 15.8619 12.1631 15.8619 12.025C15.8619 11.8869 15.8333 11.7503 15.7779 11.6238C15.7225 11.4973 15.6415 11.3837 15.54 11.29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRightB);
export default __webpack_public_path__ + "static/media/angle-right-b.dec45fc05b8379b5f60891c5d4c68e38.svg";
export { ForwardRef as ReactComponent };